class LoadRemoteScript {
  constructor ({ url, async = true, globalName = null, limitPolling = 10, type = 'text/javascript' }) {
    this.url = url
    this.async = async
    this.globalName = globalName
    this.limitPolling = limitPolling
    this.type = type
    this.target = null
    this.loadingPromise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  async load () {
    if (this.loaded) {
      this.resolve(this.loaded)
      return await this.loadingPromise
    }
    return await this.installScriptWhenCan()
  }

  async installScriptWhenCan () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.installScript())
    } else {
      setTimeout(() => this.installScript(), 0)
    }
    return await this.loadingPromise
  }

  installScript () {
    if (this.loaded) {
      this.resolve(this.loaded)
      return
    }
    const script = document.createElement('script')
    script.addEventListener('load', (e) => this.onScriptLoad(e), true)
    script.addEventListener('error', () => this.reject(new Error(`Failed to load script: ${this.url}`)), true)
    this.async && script.setAttribute('async', 'true')
    script.setAttribute('src', this.url)
    const { head } = document
    head.insertBefore(script, head.firstChild)
  }

  onScriptLoad ({ target }) {
    if (!this.globalName) {
      this.target = target
      this.resolve(target)
    } else {
      if (window[this.globalName]) {
        this.resolve(window[this.globalName])
      } else {
        this.pollForGlobal()
      }
    }
  }

  pollForGlobal () {
    let count = 0
    const interval = setInterval(() => {
      if (window[this.globalName]) {
        clearInterval(interval)
        this.resolve(window[this.globalName])
      }
      if (count++ >= this.limitPolling) {
        clearInterval(interval)
        this.reject(new Error(`Failed to load script ${this.url}`))
      }
    }, 100)
  }

  get loaded () {
    if (this.globalName && window[this.globalName]) { return window[this.globalName] }
    return this.target
  }

  static async load (args) {
    return new LoadRemoteScript(args).load()
  }
}

export default LoadRemoteScript.load
